import { Spinner } from '@/components/ui/spinner';
import { TenantDetails } from '@/store/authStore';
import { InputHTMLAttributes, useState } from 'react';
import { LogoType, logoUrls } from './lookupTenantTheme';
import { CircleX, Cross, X } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface TenantLogoSpinnerProps extends InputHTMLAttributes<HTMLImageElement> {
  tenantDetails: TenantDetails;
  logoType: LogoType;
  className: string;
}

export default function TenantLogoSpinner({
  tenantDetails,
  logoType,
  className,
  ...props
}: TenantLogoSpinnerProps) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <span className="relative flex items-center">
      <img
        src={logoUrls(tenantDetails)[logoType]}
        alt={tenantDetails.tenantName}
        className={cn(className, `${loading || error ? 'hidden' : ''}`)}
        {...props}
        onLoad={() => setLoading(false)}
        onError={() => setError(true)}
      />
      {loading && !error && (
        <span className="font-semibold">
          {tenantDetails.tenantName ? tenantDetails.tenantName : 'Watchful'}
        </span>
      )}
      {error && (
        <p className="text-lg font-semibold">
          {tenantDetails.tenantName ? tenantDetails.tenantName : 'Watchful'}
        </p>
      )}
    </span>
  );
}
